import React, { useState } from 'react';
import '../../component-styles/ScheduleSelect.css';
import API_BASE from '../../utils/api.js';

const NEW_VALUE = '__new__';

export default function ScheduleSelect({
  schedules = [],
  value,
  onChange,
  userId,
  projectId,
  onScheduleCreated,
  selectClassName = '',
  placeholder = 'Unassigned',
  disabled = false,
}) {
  const [creating, setCreating] = useState(false);
  const [newName, setNewName] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  function handleSelectChange(e) {
    const next = e.target.value;
    if (next === NEW_VALUE) {
      setCreating(true);
      setNewName('');
      setError(null);
      return;
    }
    onChange(next);
  }

  async function handleCreate() {
    const name = newName.trim();
    if (!name) return setError('Schedule name is required.');

    setSaving(true);
    setError(null);
    try {
      const res = await fetch(`${API_BASE}/api/schedules/${encodeURIComponent(userId)}/${encodeURIComponent(projectId)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || 'Failed to create schedule');

      onScheduleCreated?.(data);
      onChange(data.sk);
      setCreating(false);
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setSaving(false);
    }
  }

  if (creating) {
    return (
      <div className="schedule-select-create">
        <input
          className={selectClassName}
          type="text"
          value={newName}
          autoFocus
          placeholder="New schedule name"
          onChange={(e) => setNewName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleCreate();
            }
          }}
        />
        <div className="schedule-select-create__actions">
          <button type="button" onClick={handleCreate} disabled={saving}>
            {saving ? 'Creating…' : 'Create'}
          </button>
          <button type="button" onClick={() => setCreating(false)} disabled={saving}>
            Cancel
          </button>
        </div>
        {error && <div className="schedule-select-create__error">{error}</div>}
      </div>
    );
  }

  return (
    <select className={selectClassName} value={value || ''} disabled={disabled} onChange={handleSelectChange}>
      <option value="">{placeholder}</option>
      {schedules.map((s) => (
        <option key={s.sk} value={s.sk}>
          {s.name}
        </option>
      ))}
      {!disabled && <option value={NEW_VALUE}>+ Create new Schedule…</option>}
    </select>
  );
}
